<div
  *ngIf="pagination"
  class="d-flex flex-wrap justify-content-between align-items-center small gap-2"
>
  <!-- Itens por página -->
  <div class="form-inline d-flex align-items-center gap-2">
    <label class="form-label mb-0 mr-2">Itens por página: </label>
    <select
      class="form-select form-select-sm w-auto"
      [value]="+pagination.per_page"
      (change)="onPerPageChange($event.target['value'])"
    >
      <option
        *ngFor="let option of perPageOptions"
        [value]="+option"
        [selected]="option === pagination.per_page"
      >
        {{ option }}
      </option>
    </select>
  </div>

  <!-- Paginação -->
  <nav *ngIf="pagination.totalPages > 1">
    <ul class="pagination pagination-sm mb-0 flex-wrap">
      <li class="page-item" [class.disabled]="isFirstPage">
        <button class="page-link" (click)="onFirst()" tabindex="-1">‹‹</button>
      </li>
      <!-- Anterior -->
      <li class="page-item" [class.disabled]="pagination.page === 1">
        <button class="page-link" (click)="changePage(pagination.page - 1)">
          ‹
        </button>
      </li>

      <!-- Páginas -->
      <li
        class="page-item"
        *ngFor="let p of pagesToShow()"
        [class.active]="+p === pagination.page"
        [class.disabled]="p === '...'"
      >
        <button class="page-link" (click)="p !== '...' && changePage(+p)">
          {{ p }}
        </button>
      </li>

      <!-- Próximo -->
      <li
        class="page-item"
        [class.disabled]="pagination.page === pagination.totalPages"
      >
        <button class="page-link" (click)="changePage(pagination.page + 1)">
          ›
        </button>
      </li>
      <li class="page-item" [class.disabled]="isLastPage">
        <button class="page-link" (click)="onLast()">››</button>
      </li>
    </ul>
  </nav>

  <!-- Info -->
  <div class="text-muted text-end">
    Exibindo {{ pagination.showingResults }} de
    {{ pagination.totalResults }} resultados
  </div>
</div>
